module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073ef_banner_800x600.1992c3ba.png";